import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert, CircularProgress } from '@mui/material';
import api from '../../services/api';

export default function ChangePasswordDialog({ open, onClose }) {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (form.newPassword !== form.confirm) {
      setError('New passwords do not match');
      return;
    }
    if (form.newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/change-password', {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword
      });
      setSuccess('Password changed successfully');
      setTimeout(() => { onClose(); setSuccess(''); setForm({ currentPassword: '', newPassword: '', confirm: '' }); }, 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <TextField label="Current Password" type="password" fullWidth sx={{ mb: 2, mt: 1 }}
          value={form.currentPassword} onChange={(e) => setForm({ ...form, currentPassword: e.target.value })} />
        <TextField label="New Password" type="password" fullWidth sx={{ mb: 2 }}
          value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })} />
        <TextField label="Confirm New Password" type="password" fullWidth
          value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : 'Update Password'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
